import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WooComponentsModule } from '@scripts/woo_components.module/module';
import { DotLoader } from '../../src/shared/feedback/loader/dot-loader.component';
import { FrequencyLimitPerMonthGraph } from './components/frequency-limit-per-month-graph.component';
import { FrequencyLimitPerMonthTable } from './components/frequency-limit-per-month-table.component';
import { StatisticsDashboard } from './components/statistics-dashboard.component';
import { CampaignFrequencyReportService } from './services/campaign-frequency-report.service';

@NgModule({
  imports: [CommonModule, WooComponentsModule, FrequencyLimitPerMonthGraph, DotLoader],
  providers: [CampaignFrequencyReportService],
  declarations: [FrequencyLimitPerMonthTable, StatisticsDashboard],
  exports: [StatisticsDashboard],
})
export class WooStatisticsDashboard {}
